import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectTracks } from '@/store/tracks/selectors';

import { Button, Skeleton, Tag } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

import { EXPIRED, FINISHED, IN_PROGRESS } from './constants';

import css from './TrackId.module.scss';

export const TabBarExtraContent = ({ showCalendarModal, isMobile }) => {
  const { t } = useTranslation('TrackId');
  const { trackStudentPlanStatus, addedByAdmin, trackStudentPlanName, isLoading } = useSelector(selectTracks);

  if (!trackStudentPlanStatus && !isLoading) {
    return (
      <Button type='primary' onClick={() => showCalendarModal('add')} size={isMobile ? 'large' : undefined}>
        {t('addToPlan')}
      </Button>
    );
  }

  const getTag = () => {
    switch (trackStudentPlanStatus) {
      case IN_PROGRESS:
        return (
          <Tag icon={<SyncOutlined />} color='processing'>
            {trackStudentPlanName}
          </Tag>
        );
      case FINISHED:
        return <Tag color='success'>{trackStudentPlanName}</Tag>;
      case EXPIRED:
        return <Tag color='error'>{trackStudentPlanName}</Tag>;
      default:
        return null;
    }
  };

  return (
    <div className={css['Track-tag']}>
      {isLoading ? (
        <Skeleton.Button active size={isMobile ? 'large' : 'middle'} className={css['Track-tag-skeleton']} />
      ) : (
        <>
          {getTag()}
          {!addedByAdmin && (
            <Button
              type='primary'
              onClick={() => showCalendarModal('reschedule')}
              size={isMobile ? 'large' : 'middle'}
              disabled={trackStudentPlanStatus === FINISHED}
            >
              {t('reschedule')}
            </Button>
          )}
        </>
      )}
    </div>
  );
};
